/* eslint-disable no-extend-native */
import React, {useState, useContext} from 'react';
import {Button, Typography, MenuItem, Divider} from '@mui/material';
import {FormGroup, Menu} from '@mui/material';
import { API } from '../conf';
import { TokenContext } from '../App';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

export default function FiltresConge(props) {
    const [loading, setLoad] = useState(true)
    const [groupe, setGroupe] = useState({title: "Siège", key: 'siege'})
    const [statut, setStatut] = useState("Indifférent")
    const [date, setDate] = useState("Indifférent")
    const [employes, setEmployes] = useState([])
    const [dpt, setDpt] = useState([])
    const [token, setToken] = useContext(TokenContext)
    const [anchorEl, setAnchorEl] = useState(null);
    const [anchorEl2, setAnchorEl2] = useState(null);
    const [anchorEl3, setAnchorEl3] = useState(null);
    const dates_options =["Indifférent", "Aujourd'hui", "Demain", "Cette semaine", "Ce mois-ci"]
    const statut_options =["Indifférent", "30+ jours posés", "-24 jours au 31 déc.", "24+ jours au 31 déc."]
    
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
        setAnchorEl2(null);
        setAnchorEl3(null);
    };

    const rm_token =()=>{
        setToken()
        return []
    }
    const get_siege = () =>{ return new Promise((resolve, reject) => {
        fetch(API.concat('/utilisateurs/siege/all'), {
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token
            },
        })
        .then(response=> response.status === 200 ? response.json() : response.status === 401 ? rm_token() : [])
        .then(json => resolve(json))
    })}

    const get_pasteurs = async() =>{ return new Promise((resolve, reject) => {
        fetch(API.concat('/utilisateurs/pasteur'), {
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token
            },
        })
        .then(response=> response.status === 200 ? response.json() : response.status === 401 ? rm_token() : [])
        .then(json => resolve(json))  
    })}

    function get_dpts() {
        return new Promise((resolve, reject) => {
            fetch(API.concat('/departements'), {
                method: 'GET',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    // 'Authorization': 'Bearer ' + await AsyncStorage.getItem('token')
                },
            })
            .then(response=> response.status === 200 ? response.json() : null)
            .then(json => resolve(json))  
        })
    }

    const get_siege_conges = () =>{ return new Promise((resolve, reject) => {
        fetch(API.concat('/conges/siege/all'), {
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token
            },
        })
        .then(response=> response.status === 200 ? response.json() : response.status === 401 ? rm_token() : null)
        .then(json => resolve(json))
    })}

    Array.prototype.sum = function (key) {
        return this.reduce((a, b) => a + (b[key] || 0), 0);
    }

    function handleFiltres() {
        setLoad(true)
        props.setLoad(true)
        const employes_filter = {type: groupe.key, filtre: groupe.key==="employe" ? groupe._id : groupe.title.toLowerCase()}
        
        let date_filter = "";
        switch (date) {
            case "Aujourd'hui":
                date_filter = {type: 'day', day: new Date(new Date().toISOString().slice(0, 10)) }
                break;

            case "Demain":
                let today = new Date(new Date().toISOString().slice(0, 10))
                date_filter = {type: 'day', day: today.setDate(today.getDate()+1)}
                break;

            case "Cette semaine":
                var curr = new Date(new Date().toISOString().slice(0, 10))
                var first = curr.getDate() - curr.getDay()
                date_filter = {type: 'week', debut: new Date(curr.setDate(first)), fin: new Date(curr.setDate(first+6))}
                break;

            case "Ce mois-ci":
                const fst = new Date(new Date().toISOString().slice(0, 10))
                fst.setDate(1)
                const nxt = new Date(fst)
                nxt.setMonth(fst.getMonth()+1)
                date_filter = {type: 'month', debut: fst, fin: nxt }
                break;
        
            default:
                break;
        }

        let statut_filter = 0; 
        switch (statut) {
            case "30+ jours posés":
                statut_filter = 30
                break;

            case "-24 jours au 31 déc.":
                statut_filter = -24
                break;

            case "24+ jours au 31 déc.":
                statut_filter = 24
                break;
        
            default:
                break;
        }

        fetch(API.concat(`/conges/${JSON.stringify(employes_filter)}/${JSON.stringify(date_filter)}/${JSON.stringify(statut_filter)}`), {
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token
            },
        })
        .then(response=> response.status === 200 ? response.json() : response.status === 401 ? rm_token() : null)
        .then(json => {
            props.setData(json !== null ? json : [])
            props.setLoad(false)
            setLoad(false)
        })
    }

    React.useEffect(()=>{
        const launch = async() =>{
            get_siege_conges().then(json => {
                if(json !== null) props.setData(json)
                props.setLoad(false)
                get_siege().then(siege =>{
                    if (siege !== null) {
                        setEmployes(siege)
                    }
                    get_pasteurs().then(pastors => {
                        if(pastors!== null) setEmployes(old => old.concat(pastors))
                        get_dpts().then(dpts=>{
                            if(dpts !== null) setDpt(dpts)
                        setLoad(false)
                        })
                    })
                })
            })
        }

        launch();
    }, []);

    return(
        <>
            <FormGroup style={{display: 'flex', flexDirection:'row', alignItems:'center'}}>
                <div style={{display: 'flex', flexDirection:'row', alignItems:'center', marginBottom:10}}>
                    <Typography variant='body1' fontWeight='bold' marginRight={2}>Employé(s): </Typography>
                    <Button
                    disabled={loading}
                    aria-controls={'long-menu' }
                    aria-haspopup="true"
                    variant="outlined"
                    disableElevation
                    onClick={handleClick}
                    endIcon={<KeyboardArrowDownIcon />}
                    color='dark'
                    >
                        <span style={{textTransform: 'capitalize'}}>{groupe.title}</span>
                    </Button>
                    <Menu
                        id="long-menu"
                        MenuListProps={{
                        'aria-labelledby': 'long-button',
                        }}
                        anchorEl={anchorEl}
                        open={Boolean(anchorEl)}
                        onClose={handleClose}
                        PaperProps={{
                        style: {
                            maxHeight: 250,
                        },
                        }}
                        anchorReference='anchorEl'
                        anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'right',
                        }}
                        transformOrigin={{
                            vertical: 'top',
                            horizontal: 'right',
                        }}
                    >
                        <MenuItem key={'siege'} selected={'siege' === groupe.key} onClick={()=>{handleClose(); setGroupe({title: "Siège", key: 'siege'})}}>
                            Siège 
                        </MenuItem>
                        <MenuItem key={'pastor'} selected={'pastor' === groupe.key} onClick={()=>{handleClose(); setGroupe({title: "Pasteur", key: 'pastor'})}}>
                            Pasteurs 
                        </MenuItem>
                        <Divider />
                        <MenuItem key={'depts'} disabled>
                            <span style={{fontWeight: 'bold'}}>Départements</span>
                        </MenuItem>
                        <Divider />
                        {dpt.map((option) => (
                        <MenuItem key={option} selected={option === groupe.title} onClick={()=>{handleClose(); setGroupe({title: option, key: 'dpt'})}}>
                            {option}
                        </MenuItem>
                        ))}
                        <Divider />
                        <MenuItem key={'depts'} disabled>
                            <span style={{fontWeight: 'bold'}}>Employés</span>
                        </MenuItem>
                        <Divider />
                        {employes.map((option) => (
                        <MenuItem key={option.usr_id} selected={option._id === groupe._id} onClick={()=>{handleClose(); setStatut("Indifférent"); setGroupe({title: option.nom.concat(' '.concat(option.prenom)), key: 'employe', _id: option._id})}}>
                            <span style={{textTransform: 'capitalize'}}>{option.nom.concat(' '.concat(option.prenom))}</span> 
                        </MenuItem>
                        ))}
                    </Menu>
                </div>
                
                <div style={{display: 'flex', flexDirection:'row', alignItems:'center', marginLeft:50, marginBottom:10}}>
                    <Typography variant='body1' fontWeight='bold' marginRight={2}>Statut: </Typography>
                    <Button
                    disabled={loading || groupe.key==="employe"}
                    id="demo-customized-button"
                    aria-controls={'statut-menu'}
                    aria-haspopup="true"
                    variant="outlined"
                    disableElevation
                    onClick={(event)=> setAnchorEl2(event.currentTarget)}
                    endIcon={<KeyboardArrowDownIcon />}
                    color='dark'
                    >
                        <span style={{textTransform: 'capitalize'}}>{statut}</span>
                    </Button>
                    <Menu
                        id="statut-menu"
                        MenuListProps={{
                        'aria-labelledby': 'long-button',
                        }}
                        anchorEl={anchorEl2}
                        open={Boolean(anchorEl2)}
                        onClose={handleClose}
                        PaperProps={{
                        style: {
                            maxHeight: 250,
                        },
                        }}
                    >
                        {statut_options.map((option) => (
                        <MenuItem key={option} selected={option === 'Pyxis'} onClick={()=>{handleClose(); setStatut(option)}}>
                            {option}
                        </MenuItem>
                        ))}
                    </Menu>
                </div>
                
                <div style={{display: 'flex', flexDirection:'row', alignItems:'center', marginLeft:50, marginBottom:10}}>
                    <Typography variant='body1' fontWeight='bold' marginRight={2}>Congés: </Typography>
                    <Button
                    disabled={loading}
                    id="demo-customized-button"
                    aria-controls='date-menu'
                    aria-haspopup="true"
                    variant="outlined"
                    disableElevation
                    onClick={(event)=> setAnchorEl3(event.currentTarget)}
                    endIcon={<KeyboardArrowDownIcon />}
                    color='dark'
                    >
                        <span style={{textTransform: 'capitalize'}}>{date}</span>
                    </Button>
                    <Menu
                        id="date-menu"
                        MenuListProps={{
                        'aria-labelledby': 'long-button',
                        }}
                        anchorEl={anchorEl3}
                        open={Boolean(anchorEl3)}
                        onClose={handleClose}
                        PaperProps={{
                        style: {
                            maxHeight: 250,
                        },
                        }}
                    >
                        {dates_options.map((option) => (
                        <MenuItem key={option} selected={option === 'Pyxis'} onClick={()=>{handleClose(); setDate(option)}}>
                            {option}
                        </MenuItem>
                        ))}
                    </Menu>
                </div>

                <Button variant="contained" color="verdigris" onClick={handleFiltres} style={{marginBottom:10, marginLeft:50}}>
                    Appliquer les filtres
                </Button>
            </FormGroup>
        </>
    )
}